import { useIsFetching } from 'react-query';

import { useFullStoryPageView } from 'hooks/useFullstoryPageView';

import { GlobalFilterButton } from 'components/common/GlobalFilterButton/GlobalFilterButton';
import { GlobalFilterComponent } from 'components/common/GlobalFilterComponent/GlobalFilterComponent';
import { ActivityCodesFilter } from 'components/common/GlobalFilterComponent/components/ActivityCodesFilter/ActivityCodesFilter';
import { MilestoneFragnetFilter } from 'components/common/GlobalFilterComponent/components/MilestoneFragnetFilter/MilestoneFragnetFilter';
import { TagsFilter } from 'components/common/GlobalFilterComponent/components/TagsFilter/TagsFilter';
import { WbsFilter } from 'components/common/GlobalFilterComponent/components/WbsFilter/wbsFilter';
import { MainCardRoutingModal } from 'components/common/MainCardRoutingModal/mainCardRoutingModal';
import { BottomHeaderSection } from 'components/common/PageContainer/BottomHeaderSection';
import { HeaderWrapper } from 'components/common/PageContainer/HeaderWrapper';
import { MainContent } from 'components/common/PageContainer/MainContent';
import PageContainer from 'components/common/PageContainer/PageContainer';
import { VersionSection } from 'components/common/PageContainer/versionSection';
import { VersionWrapper } from 'components/common/PageContainer/versionWrapper';
import { PageWidgetWrapper } from 'components/common/PageWidgetWrapper/PageWidgetWrapper';
import { ProgramTopHeader } from 'components/common/ProgramTopHeader/ProgramTopHeader';

import { useScrollTo } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/ProgramProgressOverview/useScrollTo';
import { VersionCompareQueryKeys } from 'components/Dashboards/Project/Components/VersionCompare/VersionCompare.consts';
import { ChangeAnalysisWidgetWrapper } from 'components/Dashboards/Project/Components/VersionCompare/changeAnalysisWidgetWrapper';
import { VersionCompareNoData } from 'components/Dashboards/Project/Components/VersionCompare/components/versionCompareNoData/versionCompareNoData';
import { executionConfig } from 'components/Dashboards/Project/ProjectWrapper/executionConfig';
import { TreeProgramTopHeader, VersionCompareSelectorWrapper } from 'components/common';
import { VersionCompareTrackedActivities } from 'components/widgets/ChangeAnalysisTrackedActivities/versionCompareTrackedActivities';
import { ChangeSummary } from 'components/widgets/ChangeSummary/ChangeSummary';
import { CriticalPathAdded } from 'components/widgets/CriticalPathAdded/CriticalPathAdded';
import { CriticalPathRemoved } from 'components/widgets/CriticalPathRemoved/CriticalPathRemoved';
import { LargestAddedActivities } from 'components/widgets/LargestAddedActivities/LargestAddedActivities';
import { LargestDeletedActivities } from 'components/widgets/LargestDeletedActivities/LargestDeletedActivities';
import { LargestDurationVariance } from 'components/widgets/LargestDurationVariance/LargestDurationVariance';
import { LargestFloatChanges } from 'components/widgets/LargestFloatChanges/LargestFloatChanges';
import { RelationshipCountChanges } from 'components/widgets/RelationshipCountChanges/RelationshipCountChanges';
import { TopFinishDateChanges } from 'components/widgets/TopFinishDateChanges/TopFinishDateChanges';
import { RelationshipTypeChanges } from 'components/widgets/TopRelationshipTypeChanges/RelationshipTypeChanges';
import { StartDateChanges } from 'components/widgets/TopStartDateChanges/startDateChanges';
import { StatusChanges } from 'components/widgets/TopStatusChanges/statusChanges';

export const ChangeAnalysisPage = () => {
    useFullStoryPageView({ pageName: executionConfig.versionCompare.title });
    const isFetching = useIsFetching({
        predicate: (query) => {
            const key = Array.isArray(query.queryKey) ? query.queryKey[0] : query.queryKey;
            return VersionCompareQueryKeys.includes(key);
        },
    });
    useScrollTo(isFetching);
    return (
        <PageContainer>
            <HeaderWrapper>
                <VersionWrapper>
                    <VersionSection>
                        <TreeProgramTopHeader>
                            <VersionCompareSelectorWrapper allowSingleVersion={false} />
                        </TreeProgramTopHeader>
                    </VersionSection>
                    <GlobalFilterButton />
                </VersionWrapper>
                <BottomHeaderSection>
                    <ProgramTopHeader pageTitle={executionConfig.versionCompare.title} />
                    <GlobalFilterComponent
                        defaultValues={{ milestoneFragnet: null, tags: [], activityCodes: [], wbs: null }}
                    >
                        <MilestoneFragnetFilter name={'milestoneFragnet'} />
                        <TagsFilter name={'tags'} />
                        <ActivityCodesFilter name={'activityCodes'} />
                        <WbsFilter name={'wbs'} />
                    </GlobalFilterComponent>
                </BottomHeaderSection>
            </HeaderWrapper>

            <MainContent>
                <VersionCompareNoData />
                <PageWidgetWrapper>
                    <ChangeAnalysisWidgetWrapper>
                        <ChangeSummary />
                        <VersionCompareTrackedActivities />
                        <TopFinishDateChanges />
                        <StartDateChanges />
                        <StatusChanges />
                        <LargestAddedActivities />
                        <LargestDeletedActivities />
                        <CriticalPathAdded />
                        <CriticalPathRemoved />
                        <LargestFloatChanges />
                        <LargestDurationVariance />
                        <RelationshipTypeChanges />
                        <RelationshipCountChanges />
                    </ChangeAnalysisWidgetWrapper>
                </PageWidgetWrapper>
            </MainContent>
            <MainCardRoutingModal queryKeys={VersionCompareQueryKeys} />
        </PageContainer>
    );
};
